"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addBrokerSwaggerMetadata = addBrokerSwaggerMetadata;
exports.getAllBrokersSwaggerMetadata = getAllBrokersSwaggerMetadata;
exports.getBrokerByIdSwaggerMetadata = getBrokerByIdSwaggerMetadata;
exports.updateBrokerSwaggerMetadata = updateBrokerSwaggerMetadata;
exports.deleteBrokerSwaggerMetadata = deleteBrokerSwaggerMetadata;
exports.getBrokerListSwaggerMetadata = getBrokerListSwaggerMetadata;
exports.getBrokerDetailsSwaggerMetadata = getBrokerDetailsSwaggerMetadata;
exports.getBrokerContactsSwaggerMetadata = getBrokerContactsSwaggerMetadata;
const common_1 = require("@nestjs/common");
const swagger_1 = require("@nestjs/swagger");
const create_broker_dto_1 = require("./dto/create-broker.dto");
const update_broker_dto_1 = require("./dto/update-broker.dto");
function addBrokerSwaggerMetadata() {
    return (0, common_1.applyDecorators)((0, swagger_1.ApiOperation)({
        summary: "Add a new broker",
        description: "Creates a new broker with the provided details, including address information.",
    }), (0, swagger_1.ApiBearerAuth)("access-token"), (0, swagger_1.ApiBody)({
        description: "Details of the broker to be created, including address information.",
        type: create_broker_dto_1.CreateBrokerDto,
    }), (0, swagger_1.ApiResponse)({
        status: 201,
        description: "Broker created successfully.",
        schema: {
            type: "object",
            properties: {
                status: { type: "number", example: 201 },
                message: { type: "string", example: "Broker created successfully" },
                data: {
                    type: "object",
                    properties: {
                        id: { type: "number", example: 66 },
                        brokerName: { type: "string", example: "ABC Brokers Pvt Ltds" },
                        displayName: { type: "string", example: "ABC Brokers" },
                        website: {
                            type: "string",
                            example: "https://www.abcbrokers.com",
                        },
                        remarks: {
                            type: "string",
                            example: "Leading insurance broker in the region",
                        },
                        companyTypeLid: { type: "number", example: 19 },
                        companyType: {
                            type: "object",
                            properties: {
                                id: { type: "number", example: 19 },
                                lookUpValue: { type: "string", example: "Public" },
                            },
                        },
                        status: {
                            type: "object",
                            properties: {
                                id: { type: "number", example: 274 },
                                lookUpValue: { type: "string", example: "Active" },
                            },
                        },
                        brokerAddresses: {
                            type: "array",
                            items: {
                                type: "object",
                                properties: {
                                    id: { type: "number", example: 1365 },
                                    addressTypeLid: { type: "number", example: 25 },
                                    addressType: {
                                        type: "object",
                                        properties: {
                                            id: { type: "number", example: 25 },
                                            lookUpValue: { type: "string", example: "Office" },
                                        },
                                    },
                                    address1: { type: "string", example: "123 Main St" },
                                    countryId: {
                                        type: "object",
                                        properties: {
                                            name: { type: "string", example: "India" },
                                            isoCode: { type: "string", example: null },
                                            id: { type: "number", example: 1 },
                                        },
                                    },
                                    stateId: {
                                        type: "object",
                                        properties: {
                                            name: { type: "string", example: "Andhra Pradesh" },
                                            stateCode: { type: "string", example: "AP" },
                                            id: { type: "number", example: 1 },
                                        },
                                    },
                                    cityId: {
                                        type: "object",
                                        properties: {
                                            name: { type: "string", example: "Visakhapatnam" },
                                            id: { type: "number", example: 1 },
                                        },
                                    },
                                    address2: { type: "string", example: "Address v23" },
                                    area: { type: "string", example: "Downtown" },
                                    pinCode: { type: "string", example: "12345" },
                                    phoneNumber: { type: "string", example: "1234567890" },
                                    alternatePhoneNumber: {
                                        type: "string",
                                        example: "0987654321",
                                    },
                                    email: { type: "string", example: "email@1811.com" },
                                    supportNumber: { type: "string", example: "1234567890" },
                                },
                            },
                        },
                    },
                },
            },
        },
    }), (0, swagger_1.ApiResponse)({
        status: 400,
        description: "Invalid input data.",
    }), (0, swagger_1.ApiResponse)({
        status: 500,
        description: "Internal server error.",
    }));
}
function getAllBrokersSwaggerMetadata() {
    return (0, common_1.applyDecorators)((0, swagger_1.ApiOperation)({
        summary: "Get all brokers",
        description: "Retrieves a list of all brokers, including their associated addresses.",
    }), (0, swagger_1.ApiBearerAuth)("access-token"), (0, swagger_1.ApiQuery)({
        name: "page",
        required: false,
        example: 1,
        description: "Page number for pagination (optional).",
    }), (0, swagger_1.ApiQuery)({
        name: "limit",
        required: false,
        example: 10,
        description: "Number of records per page(by default limit is 10 records) (optional).",
    }), (0, swagger_1.ApiQuery)({
        name: "sort",
        required: false,
        example: "brokerName:DESC",
        description: "Field to sort by (optional).",
    }), (0, swagger_1.ApiQuery)({
        name: "search",
        required: false,
        example: "brokerName:test",
        description: "Search term to filter results (optional).",
    }), (0, swagger_1.ApiQuery)({
        name: "searchBy",
        required: false,
        example: "test",
        description: "Search based on brokerName.",
    }), (0, swagger_1.ApiResponse)({
        status: 200,
        description: "Broker list retrieved successfully.",
        schema: {
            type: "object",
            properties: {
                status: { type: "number", example: 200 },
                message: {
                    type: "string",
                    example: "Broker list retrieved successfully",
                },
                data: {
                    type: "array",
                    items: {
                        type: "object",
                        properties: {
                            id: { type: "number", example: 1 },
                            brokerName: { type: "string", example: "ABC Brokers Pvt Ltd" },
                            displayName: { type: "string", example: "ABC Brokers" },
                            companyType: { type: "string", example: "Private" },
                            website: {
                                type: "string",
                                example: "https://www.abcbrokers.com",
                            },
                            remarks: {
                                type: "string",
                                example: "Leading insurance broker in the region",
                            },
                            addresses: {
                                type: "array",
                                items: {
                                    type: "object",
                                    properties: {
                                        id: { type: "number", example: 101 },
                                        addressLine1: {
                                            type: "string",
                                            example: "123 Main Street",
                                        },
                                        cityId: { type: "number", example: 1 },
                                        stateId: { type: "number", example: 2 },
                                        countryId: { type: "number", example: 3 },
                                        postalCode: { type: "string", example: "123456" },
                                    },
                                },
                            },
                            count: { type: "number", example: 56 },
                            totalBrokers: { type: "number", example: 56 },
                        },
                    },
                },
            },
        },
    }), (0, swagger_1.ApiResponse)({
        status: 404,
        description: "No brokers found.",
    }), (0, swagger_1.ApiResponse)({
        status: 500,
        description: "Internal server error.",
    }));
}
function getBrokerByIdSwaggerMetadata() {
    return (0, common_1.applyDecorators)((0, swagger_1.ApiOperation)({
        summary: "Get a broker by ID",
        description: "Retrieves details of a specific broker by its ID, including associated addresses.",
    }), (0, swagger_1.ApiBearerAuth)("access-token"), (0, swagger_1.ApiResponse)({
        status: 200,
        description: "Broker retrieved successfully.",
        schema: {
            type: "object",
            properties: {
                status: { type: "number", example: 200 },
                message: {
                    type: "string",
                    example: "Broker retrieved successfully.",
                },
                data: {
                    type: "object",
                    properties: {
                        id: { type: "number", example: 1 },
                        brokerName: { type: "string", example: "ABC Brokers Pvt Ltd" },
                        displayName: { type: "string", example: "ABC Brokers" },
                        companyType: { type: "string", example: "Private" },
                        website: {
                            type: "string",
                            example: "https://www.abcbrokers.com",
                        },
                        remarks: {
                            type: "string",
                            example: "Leading insurance broker in the region",
                        },
                        addresses: {
                            type: "array",
                            items: {
                                type: "object",
                                properties: {
                                    id: { type: "number", example: 101 },
                                    addressLine1: {
                                        type: "string",
                                        example: "123 Main Street",
                                    },
                                    cityId: { type: "number", example: 1 },
                                    stateId: { type: "number", example: 2 },
                                    countryId: { type: "number", example: 3 },
                                    postalCode: { type: "string", example: "123456" },
                                },
                            },
                        },
                    },
                },
            },
        },
    }), (0, swagger_1.ApiResponse)({
        status: 404,
        description: "Broker not found.",
    }), (0, swagger_1.ApiResponse)({
        status: 500,
        description: "Internal server error.",
    }));
}
function updateBrokerSwaggerMetadata() {
    return (0, common_1.applyDecorators)((0, swagger_1.ApiOperation)({
        summary: "Update a broker",
        description: "Updates the details of an existing broker.",
    }), (0, swagger_1.ApiBearerAuth)("access-token"), (0, swagger_1.ApiBody)({
        description: "Updated broker details, including addresses.",
        type: update_broker_dto_1.UpdateBrokerDto,
    }), (0, swagger_1.ApiResponse)({
        status: 200,
        description: "Broker updated successfully.",
        schema: {
            type: "object",
            properties: {
                status: { type: "number", example: 200 },
                message: { type: "string", example: "Broker updated successfully." },
                data: {
                    type: "object",
                    properties: {
                        id: { type: "number", example: 1 },
                        brokerName: { type: "string", example: "ABC Brokers Pvt Ltd" },
                        displayName: { type: "string", example: "ABC Brokers" },
                        companyType: { type: "string", example: "Private" },
                        website: {
                            type: "string",
                            example: "https://www.abcbrokers.com",
                        },
                        remarks: { type: "string", example: "Updated broker details" },
                        addresses: {
                            type: "array",
                            items: {
                                type: "object",
                                properties: {
                                    id: { type: "number", example: 101 },
                                    addressLine1: {
                                        type: "string",
                                        example: "123 Main Street",
                                    },
                                    cityId: { type: "number", example: 1 },
                                    stateId: { type: "number", example: 2 },
                                    countryId: { type: "number", example: 3 },
                                    postalCode: { type: "string", example: "123456" },
                                },
                            },
                        },
                    },
                },
            },
        },
    }), (0, swagger_1.ApiResponse)({
        status: 404,
        description: "Broker not found.",
    }), (0, swagger_1.ApiResponse)({
        status: 400,
        description: "Invalid input data.",
    }), (0, swagger_1.ApiResponse)({
        status: 500,
        description: "Internal server error.",
    }));
}
function deleteBrokerSwaggerMetadata() {
    return (0, common_1.applyDecorators)((0, swagger_1.ApiOperation)({
        summary: "Delete a broker",
        description: "Deletes a broker by its ID.",
    }), (0, swagger_1.ApiBearerAuth)("access-token"), (0, swagger_1.ApiResponse)({
        status: 200,
        description: "Broker successfully deleted.",
        schema: {
            type: "object",
            properties: {
                status: { type: "number", example: 200 },
                message: { type: "string", example: "Broker successfully deleted." },
            },
        },
    }), (0, swagger_1.ApiResponse)({
        status: 404,
        description: "Broker not found.",
    }), (0, swagger_1.ApiResponse)({
        status: 500,
        description: "Internal server error.",
    }));
}
function getBrokerListSwaggerMetadata() {
    return (0, common_1.applyDecorators)((0, swagger_1.ApiOperation)({
        summary: "Get all Brokers List",
        description: "Retrieves a list of all Brokers, including their associated addresses.",
    }), (0, swagger_1.ApiBearerAuth)("access-token"), (0, swagger_1.ApiQuery)({
        name: "page",
        required: false,
        example: 1,
        description: "Page number for pagination (optional).",
    }), (0, swagger_1.ApiQuery)({
        name: "limit",
        required: false,
        example: 10,
        description: "Number of records per page(by default limit is 10 records) (optional).",
    }), (0, swagger_1.ApiQuery)({
        name: "sortBy",
        required: false,
        example: "createdAt",
        description: "Field to sort by (optional).",
    }), (0, swagger_1.ApiQuery)({
        name: "sortOrder",
        required: false,
        example: "ASC",
        description: "Sort order: ASC or DESC (optional).",
    }), (0, swagger_1.ApiQuery)({
        name: "search",
        required: false,
        example: "Test",
        description: "Search term to filter results (optional).",
    }), (0, swagger_1.ApiResponse)({
        status: 200,
        description: "Broker list retrieved successfully",
        schema: {
            type: "object",
            properties: {
                status: { type: "number", example: 200 },
                message: {
                    type: "string",
                    example: "Broker list retrieved successfully",
                },
                data: {
                    type: "array",
                    items: {
                        type: "object",
                        properties: {
                            id: { type: "number", example: 44 },
                            brokerName: { type: "string", example: "Abhi" },
                            displayName: { type: "string", example: "Test Display" },
                        },
                    },
                },
                total: { type: "number", example: 56 },
            },
        },
    }), (0, swagger_1.ApiResponse)({
        status: 404,
        description: "No Brokers found.",
    }), (0, swagger_1.ApiResponse)({
        status: 500,
        description: "Internal server error.",
    }));
}
function getBrokerDetailsSwaggerMetadata() {
    return (0, common_1.applyDecorators)((0, swagger_1.ApiOperation)({
        summary: "Get broker details by ID",
        description: "Retrieves details of a specific broker by its ID, including associated addresses.",
    }), (0, swagger_1.ApiBearerAuth)("access-token"), (0, swagger_1.ApiBearerAuth)("access-token"), (0, swagger_1.ApiParam)({
        name: "id",
        required: true,
        description: "ID of the broker",
        example: 44,
    }), (0, swagger_1.ApiResponse)({
        status: 200,
        description: "Broker details retrieved successfully.",
        schema: {
            type: "object",
            properties: {
                status: { type: "number", example: 200 },
                message: {
                    type: "string",
                    example: "Broker details retrieved successfully",
                },
                data: {
                    type: "object",
                    properties: {
                        id: { type: "number", example: 44 },
                        brokerName: { type: "string", example: "Abhi" },
                        displayName: { type: "string", example: "Test Display" },
                        brokerAddresses: {
                            type: "array",
                            items: {
                                type: "object",
                                properties: {
                                    id: { type: "number", example: 325 },
                                    address1: { type: "string", example: "test nagar ofice" },
                                    city: {
                                        type: "object",
                                        properties: {
                                            name: { type: "string", example: "Visakhapatnam" },
                                            id: { type: "number", example: 1 },
                                        },
                                    },
                                },
                            },
                        },
                    },
                },
            },
        },
    }), (0, swagger_1.ApiResponse)({
        status: 404,
        description: "Broker not found.",
    }), (0, swagger_1.ApiResponse)({
        status: 500,
        description: "Internal server error.",
    }));
}
function getBrokerContactsSwaggerMetadata() {
    return (0, common_1.applyDecorators)((0, swagger_1.ApiOperation)({
        summary: "Get contacts of a broker",
        description: "Fetches all contacts associated with a specific broker.",
    }), (0, swagger_1.ApiBearerAuth)("access-token"), (0, swagger_1.ApiParam)({
        name: "brokerId",
        required: true,
        description: "ID of the broker",
        example: 123,
    }), (0, swagger_1.ApiResponse)({
        status: 200,
        description: "Broker contacts retrieved successfully.",
        schema: {
            example: {
                status: 200,
                message: "Broker contacts retrieved successfully",
                data: [
                    {
                        id: 583,
                        firstName: "Navanitha",
                        lastName: "Makulla",
                        displayName: "Navanitha Makulla",
                    },
                    {
                        id: 578,
                        firstName: "Test Broker",
                        lastName: "Label",
                        displayName: "Test Broker Label",
                    },
                ],
            },
        },
    }), (0, swagger_1.ApiResponse)({
        status: 404,
        description: "No contacts found for broker.",
    }), (0, swagger_1.ApiResponse)({
        status: 500,
        description: "Failed to fetch broker contacts.",
    }));
}
